import { render, staticRenderFns } from "./ExchangeTruckListing.vue?vue&type=template&id=fa8990ca&scoped=true"
import script from "./ExchangeTruckListing.vue?vue&type=script&lang=js"
export * from "./ExchangeTruckListing.vue?vue&type=script&lang=js"
import style0 from "./ExchangeTruckListing.vue?vue&type=style&index=0&id=fa8990ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8990ca",
  null
  
)

export default component.exports